import React, { useContext, useState } from 'react'
import SearchBox from './SearchBox'
import { Context } from 'Context/Context';
import { useNavigate } from 'react-router-dom';
import { searchWithCaseNumberApi } from 'Constants';
import TestModal from 'Modals/TestModal';
import NoCaseFoundModal from 'Modals/NoCaseFoundModal';

function SearchContentProf({attorney, size = null, setUpdateComp, variant = null}) {
    const {makeApiCallFunc} = useContext(Context);
    const [refreshList, setRefreshList] = useState(false);
    const [currentCaseId, setCurrentCaseId] = useState(null);
    const [caseNumber, setCaseNumber] = useState(null);
    const [showErrorModal, setShowErrorModal] = useState(false);    
    const [singleCase, setSingleCase] = useState(null);
    
    const [showModal, setShowModal] = useState(false)
    const navigate = useNavigate();
    const handleSearchSubmit = (value) => {
        setCaseNumber(value);
        makeApiCallFunc(searchWithCaseNumberApi, {caseNumber : value}, ({data}) => {
            if(Object.keys(data).length === 0) 
            {
                setShowErrorModal(true);
                
            }
            else
            {
                
               setCurrentCaseId(data?._id);
                setShowModal(true);
            }
        }, (error) => console.log(error));
       
    }
  return (
        <>
        {/* Show Modal on searching case number */}
        {
        showModal &&
        <TestModal 
        attorney={attorney} 
        caseId = {currentCaseId} 
        setUpdateComp={setUpdateComp}
        setRefreshList={setRefreshList}
        setSingleCase={setSingleCase}
        caseNumber={caseNumber}  
        onClose={() => {
                setShowModal(false);   // close modal
                if(refreshList)
                {
                    console.log("setUpdatecomp", setUpdateComp);
                    setUpdateComp(prev => !prev);
                    setRefreshList(false);
                } 
                }}
        uploadNew={showModal}/>
        }
        {
            showErrorModal &&
            <NoCaseFoundModal onClose = {() => setShowErrorModal(false)} uploadNew = {showErrorModal}/>
        }
        
        <SearchBox size={size} variant={variant} handleSubmit = {(value) => handleSearchSubmit(value)} placeholder={variant ? "Search by case ID" : "Search Cases By Case ID"}/>
        </>
  )
}

export default SearchContentProf